// extracted by mini-css-extract-plugin
export default {"wrapper":"UserBox__wrapper--6NGTfr","content":"UserBox__content--fOHBOz","name":"UserBox__name--JFakD0","email":"UserBox__email--OcqtlK"};